/** Minimum zoom for the heavy detail layers (transformers, meters, devices,
 *  secondary conductors). Below this the layers neither fetch nor render —
 *  the map shows a "zoom in to load" hint instead (spec D-9). Value matches
 *  the original secondary-layer gate (SECONDARY_MIN_ZOOM), which this
 *  generalizes. Search fly-to zooms (16–18) always land above it. */
export const DETAIL_MIN_ZOOM = 15

/** Zoom-gated layer keys with plain-English hint labels, in display order. */
const ZOOM_GATED_LAYERS: ReadonlyArray<{ key: string; label: string }> = [
  { key: 'transformers', label: 'transformers' },
  { key: 'meters', label: 'meters' },
  { key: 'devices', label: 'devices' },
  { key: 'secondary', label: 'secondary conductors' },
]

/**
 * Labels of the toggled-on layers currently suppressed by the zoom gate,
 * for the "Zoom in to load …" banner. Empty when zoomed in far enough
 * (or when no gated layer is toggled on) — empty means no banner.
 */
export function zoomGatedLayerLabels(
  zoom: number,
  visibleLayers: Record<string, boolean>,
): string[] {
  if (zoom >= DETAIL_MIN_ZOOM) return []
  return ZOOM_GATED_LAYERS.filter(l => visibleLayers[l.key]).map(l => l.label)
}
